// WARNING: DO NOT EDIT. This file is Auto-Generated by AWS Mobile Hub. It will be overwritten.

// Copyright 2017-2018 Amazon.com, Inc. or its affiliates (Amazon). All Rights Reserved.
// Code generated by AWS Mobile Hub. Amazon gives unlimited permission to
// copy, distribute and modify it.

// AWS Mobile Hub Project Constants
const awsmobile = {
    'aws_app_analytics': 'enable',
    'aws_cloud_logic': 'enable',
    'aws_cloud_logic_custom': [{"id":"8mvrxpgnb7","name":"Days","description":"","endpoint":"https://8mvrxpgnb7.execute-api.us-east-1.amazonaws.com/Development","region":"us-east-1","paths":["/items","/items/123"]}],
    'aws_cognito_identity_pool_id': 'us-east-1:62afc3f2-e947-48b2-af03-b29b6220fed2',
    'aws_cognito_region': 'us-east-1',
    'aws_content_delivery': 'enable',
    'aws_content_delivery_bucket': 'daybookv-hosting-mobilehub-1866168127',
    'aws_content_delivery_bucket_region': 'us-east-1',
    'aws_content_delivery_cloudfront': 'enable',
    'aws_content_delivery_cloudfront_domain': 'dswpvzymin8xc.cloudfront.net',
    'aws_dynamodb': 'enable',
    'aws_dynamodb_all_tables_region': 'us-east-1',
    'aws_dynamodb_table_schemas': [{"tableName":"daybookv-mobilehub-1866168127-days","attributes":[{"name":"userId","type":"S"},{"name":"dayId","type":"S"}],"indexes":[],"region":"us-east-1","hashKey":"userId","rangeKey":"dayId"}],
    'aws_mobile_analytics_app_id': 'a3c2ed3c80a9463cb945a9416ca6419c',
    'aws_mobile_analytics_app_region': 'us-east-1',
    'aws_project_id': 'de418244-1c62-493e-a221-05a75d43ac05',
    'aws_project_name': 'day-book-v4',
    'aws_project_region': 'us-east-1',
    'aws_push_apns': 'enable',
    'aws_push_pinpoint': 'enable',
    'aws_resource_bucket_name': 'daybookv-deployments-mobilehub-1866168127',
    'aws_resource_name_prefix': 'daybookv-mobilehub-1866168127',
    'aws_sign_in_enabled': 'enable',
    'aws_user_files': 'enable',
    'aws_user_files_s3_bucket': 'daybookv-userfiles-mobilehub-1866168127',
    'aws_user_files_s3_bucket_region': 'us-east-1',
    'aws_user_pools': 'enable',
    'aws_user_pools_id': 'us-east-1_V59a15UaV',
    'aws_user_pools_mfa_type': 'ON',
    'aws_user_pools_web_client_id': '4cqsj6vt9bialinh2u8tk0nsaf',
}

export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js